import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setChangeWidgetSize: Function // function to set updated widget size
}

// component to render widget size settings
const WidgetSize = (props: PropTypes) => {

    // Props
    const { setChangeWidgetSize } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    // States
    const [widgetSize, setWidgetSize] = useState<number>(0);
    console.log('widgetSize: ', widgetSize);

    
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if widget size is set to 1
            if (currentWebsite.widget_size === 1) {
                setWidgetSize(1);
            } else {
                setWidgetSize(0);
            }
        }
    }, [currentWebsite]);

    
    useEffect(() => {
        // check widget size is set to 1
        if (widgetSize === 1) {
            setChangeWidgetSize(1);
        } else {
            setChangeWidgetSize(0);
        }
    }, [widgetSize]);
    

    return (
        <>
            <div className="aioa_dashboard-widget-settings-btns">
                <Button onClick={() => setWidgetSize(1)} className={`${widgetSize === 1 ? 'active' : ''}`} size="lg">{t('widget oversize label')}</Button>
                <Button onClick={() => setWidgetSize(0)} className={`${widgetSize === 0 ? 'active' : ''}`} size="lg">{t('widget regular label')}</Button>
            </div>
        </>
    )
}

export default WidgetSize;